function scrollToFirstError(element: HTMLElement) {
  const focusableErrors = [
    ...element.querySelectorAll('[data-focusable-error="true"]'),
  ].sort((elA, elB) =>
    elA.getBoundingClientRect().top > elB.getBoundingClientRect().top ? 1 : -1,
  );

  if (focusableErrors.length > 0) {
    getNearestScrollableElement(element).scrollBy({
      top: focusableErrors[0].getBoundingClientRect().top - 50,
      left: 0,
      behavior: 'smooth',
    });
  }
}

function getNearestScrollableElement(element: HTMLElement) {
  // TODO: temporary fix due to some Vue 3 changes
  if (element.id === 'app') {
    return window;
  }

  if (element === document.body) {
    return window;
  }

  if (isElementScrollable(element)) {
    return element;
  }

  if (element.parentElement) {
    return getNearestScrollableElement(element.parentElement);
  }

  throw new Error('No scrollable element found');
}

// Inspired by: https://htmldom.dev/check-if-an-element-is-scrollable/
function isElementScrollable(element: HTMLElement) {
  // Compare the height to see if the element has scrollable content
  const hasScrollableContent = element.scrollHeight > element.clientHeight;

  if (!hasScrollableContent) {
    return false;
  }

  // It's not enough because the element's `overflow-y` style can be set as
  // * `hidden`
  // * `hidden !important`
  // In those cases, the scrollbar isn't shown
  const overflowYStyle = window.getComputedStyle(element).overflowY;
  const isOverflowHidden = overflowYStyle.indexOf('hidden') !== -1;

  return !isOverflowHidden;
}

export default scrollToFirstError;
